import "./style.scss";

import { TabContext, TabPanel } from "@mui/lab";
import { Checkbox, FormControlLabel, FormGroup, MenuItem, Select, TextField } from "@mui/material";
import ButtonBase from "components/shared/ButtonBase";
import LabelComponent from "components/shared/LabelComponent";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

const SignUp = () => {
    const [t] = useTranslation();
    const [page, setPage] = useState("0");

    const { control, handleSubmit, getValues, watch } = useForm({
        defaultValues: {
            firstname: "",
            lastname: "",
            email: "",
            password: "",
            confirmPassword: "",
            companyName: "",
            industry: "",
            companyNumber: "",
            companyAddress: "",
            termsOfService: false,
        },
    });

    const handleNext = () => setPage("1");

    const onSubmit = async (data: any) => {};

    const tabStyle = { height: "100%", padding: 0 };

    return (
        <div className="SignUpComponent">
            <form onSubmit={handleSubmit(onSubmit)}>
                <TabContext value={page}>
                    <TabPanel value="0" sx={tabStyle}>
                        <div className="tabContainer">
                            <div className="signUp-container">
                                <div className="signup-title">
                                    <h1>{t("SignUp.CreateYourAccount")}</h1>
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. In pellentesque at
                                        tempor in dolor cursus sed varius. Sed amet lorem porttitor elit.
                                    </p>
                                </div>
                                <div className="signup-names">
                                    <Controller
                                        name="firstname"
                                        control={control}
                                        render={({ field }) => {
                                            return (
                                                <div className="signup-fields">
                                                    <LabelComponent htmlFor="firstname">
                                                        {t("SignUp.Firstname")}
                                                    </LabelComponent>
                                                    <TextField
                                                        {...field}
                                                        placeholder={t("SignUp.FirstnameHere")}
                                                        fullWidth
                                                    />
                                                </div>
                                            );
                                        }}
                                    />
                                    <Controller
                                        name="lastname"
                                        control={control}
                                        render={({ field }) => {
                                            return (
                                                <div className="signup-fields">
                                                    <LabelComponent htmlFor="lastname">
                                                        {t("SignUp.Lastname")}
                                                    </LabelComponent>
                                                    <TextField
                                                        {...field}
                                                        placeholder={t("SignUp.LastnameHere")}
                                                        fullWidth
                                                    />
                                                </div>
                                            );
                                        }}
                                    />
                                </div>
                                <Controller
                                    name="email"
                                    control={control}
                                    render={({ field }) => {
                                        return (
                                            <div className="signup-fields">
                                                <LabelComponent htmlFor="email">{t("SignUp.Email")}</LabelComponent>
                                                <TextField {...field} placeholder={t("SignUp.EmailHere")} fullWidth />
                                            </div>
                                        );
                                    }}
                                />
                                <Controller
                                    name="password"
                                    control={control}
                                    render={({ field }) => {
                                        return (
                                            <div className="signup-fields">
                                                <LabelComponent htmlFor="password">
                                                    {t("SignUp.Password")}
                                                </LabelComponent>
                                                <p>{t("SignUp.PasswordRules")}</p>
                                                <TextField
                                                    {...field}
                                                    type="password"
                                                    placeholder={t("SignUp.PasswordHere")}
                                                    fullWidth
                                                />
                                            </div>
                                        );
                                    }}
                                />
                                <Controller
                                    name="confirmPassword"
                                    control={control}
                                    render={({ field }) => {
                                        return (
                                            <div className="signup-fields">
                                                <LabelComponent htmlFor="confirmPassword">
                                                    {t("SignUp.ConfirmPassword")}
                                                </LabelComponent>
                                                <TextField
                                                    {...field}
                                                    type="password"
                                                    placeholder={t("SignUp.ConfirmPasswordHere")}
                                                    fullWidth
                                                />
                                            </div>
                                        );
                                    }}
                                />
                                <ButtonBase variant="contained" onClick={handleNext}>
                                    {t("SignUp.Next")} {">"}
                                </ButtonBase>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel value="1" sx={tabStyle}>
                        <div className="tabContainer">
                            <div className="company-information-container">
                                <div className="signup-title">
                                    <h1>{t("SignUp.CompanyInfo")}</h1>
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. In pellentesque at
                                        tempor in dolor cursus sed varius. Sed amet lorem porttitor elit.
                                    </p>
                                </div>
                                <Controller
                                    name="companyName"
                                    control={control}
                                    render={({ field }) => {
                                        return (
                                            <div className="signup-fields">
                                                <LabelComponent htmlFor="companyName">
                                                    {t("SignUp.CompanyName")}*
                                                </LabelComponent>
                                                <TextField
                                                    {...field}
                                                    placeholder={t("SignUp.CompanyNameHere")}
                                                    fullWidth
                                                />
                                            </div>
                                        );
                                    }}
                                />
                                <Controller
                                    name="industry"
                                    control={control}
                                    render={({ field }) => {
                                        return (
                                            <div className="signup-fields">
                                                <LabelComponent htmlFor="industry">
                                                    {t("SignUp.Industry")}*
                                                </LabelComponent>
                                                <Select
                                                    {...field}
                                                    fullWidth
                                                    displayEmpty
                                                    renderValue={
                                                        getValues("industry") == ""
                                                            ? () => (
                                                                  <div style={{ color: "#aaa" }}>
                                                                      {t("SignUp.IndustryHere")}
                                                                  </div>
                                                              )
                                                            : undefined
                                                    }
                                                >
                                                    <MenuItem value={"it"}>{t("SignUp.IT")}</MenuItem>
                                                    <MenuItem value={"ecology"}>{t("SignUp.Ecology")}</MenuItem>
                                                    <MenuItem value={"textile"}>{t("SignUp.Textile")}</MenuItem>
                                                </Select>
                                            </div>
                                        );
                                    }}
                                />
                                <Controller
                                    name="companyNumber"
                                    control={control}
                                    render={({ field }) => {
                                        return (
                                            <div className="signup-fields">
                                                <LabelComponent htmlFor="companyNumber">
                                                    {t("SignUp.CompanyNumber")}
                                                </LabelComponent>
                                                <TextField
                                                    {...field}
                                                    placeholder={t("SignUp.CompanyNumberHere")}
                                                    fullWidth
                                                />
                                            </div>
                                        );
                                    }}
                                />
                                <Controller
                                    name="companyAddress"
                                    control={control}
                                    render={({ field }) => {
                                        return (
                                            <div className="signup-fields">
                                                <LabelComponent htmlFor="companyAddress">
                                                    {t("SignUp.CompanyAddress")}
                                                </LabelComponent>
                                                <TextField
                                                    {...field}
                                                    placeholder={t("SignUp.CompanyAddressHere")}
                                                    fullWidth
                                                />
                                            </div>
                                        );
                                    }}
                                />
                                <p>*{t("SignUp.Required")}</p>
                                <Controller
                                    name="termsOfService"
                                    control={control}
                                    render={({ field }) => {
                                        return (
                                            <div className="signup-fields">
                                                <FormGroup {...field}>
                                                    <FormControlLabel
                                                        control={<Checkbox />}
                                                        label={t("SignUp.TermsOfService")}
                                                    />
                                                </FormGroup>
                                            </div>
                                        );
                                    }}
                                />
                                <ButtonBase variant="contained" type="submit" disabled={!watch("termsOfService")}>
                                    {t("SignUp.Start")}
                                </ButtonBase>
                            </div>
                        </div>
                    </TabPanel>
                </TabContext>
            </form>
        </div>
    );
};

export default SignUp;
